import { Body2, Caption1 } from '@ui/Typography'
import { Checkbox } from '@ui/components/Checkbox'

import { Box } from '@shared/components/Box'

interface InstrumentSelectRowProps {
  symbol: string
  symbolDescription?: string | null
  selected: boolean
  onToggle: (symbol: string) => void
}

export const InstrumentSelectRow = ({
  symbol,
  symbolDescription,
  selected,
  onToggle,
}: InstrumentSelectRowProps) => (
  <Box flex align='center' justify='space-between' p='x8' cursor='pointer'>
    <Box flex direction='column'>
      <Body2 medium>{symbol}</Body2>
      {symbolDescription && <Caption1 color='text-med-em'>{symbolDescription}</Caption1>}
    </Box>
    <Checkbox checked={selected} onChange={() => onToggle(symbol)} />
  </Box>
)
